import { useEffect, useState } from 'react';
import { useVault } from '../session/useVault';
import { loadWorkspaces } from './loadWorkspaces';
import type { Workspace } from './workspace';

export type WorkspacesRead =
  | { status: 'reading' }
  | { status: 'ready'; workspaces: Workspace[] }
  | { status: 'failed' };

/**
 * Every nook, read again when the write queue changes state, so a save made
 * here — a pin — shows without waiting on a re-read of the vault.
 */
export function useWorkspaces(enabled = true): WorkspacesRead {
  const { state, queue } = useVault();
  const [read, setRead] = useState<WorkspacesRead>({ status: 'reading' });

  useEffect(() => {
    if (state.status !== 'ready' || !enabled) return;
    let cancelled = false;
    loadWorkspaces(state.vault)
      .then((workspaces) => !cancelled && setRead({ status: 'ready', workspaces }))
      .catch(() => !cancelled && setRead({ status: 'failed' }));
    return () => {
      cancelled = true;
    };
  }, [state, enabled, queue.state]);

  return read;
}
